import { type PropsWithChildren } from "react";
import { TableCell, cn } from "ui";

import {
  PINNED_CELL,
  PINNED_CELL_FADE,
} from "src/components/pinnedTableCell.shared";

const HOVER_BACKGROUND =
  "group-hover/table-row:bg-[color-mix(in_oklab,var(--color-muted)_50%,var(--color-background))]";

const HOVER_FADE =
  "before:to-transparent group-hover/table-row:before:to-[color-mix(in_oklab,var(--color-muted)_50%,var(--color-background))]";

interface PinnedTableCellProps extends PropsWithChildren {
  fade: boolean;
  className?: string;
}

export function PinnedTableCell(props: PinnedTableCellProps) {
  return (
    <TableCell className={cn(PINNED_CELL, "p-0")}>
      <div
        className={cn(
          "relative",
          HOVER_BACKGROUND,
          props.fade && cn(PINNED_CELL_FADE, HOVER_FADE),
          props.className,
        )}
      >
        {props.children}
      </div>
    </TableCell>
  );
}
